export const alertTypes = {
  'Review Rule Match - Information Updated': 'A',
  'Review Rule Match - Decision Needed': 'B',
  'Review Rule Match - Follow Up For Details': 'C',
};
